import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'activity', 'IconActivity', [["path",{"d":"M3 12h4l3 8l4 -16l3 8h4","key":"svg-0"}]]);